<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Point`]" width="1em" height="1em" v-bind="$attrs"><path d="M6 10.1315V5.86852C6 5.06982 6.89014 4.59343 7.5547 5.03647L10.7519 7.16795C11.3457 7.56377 11.3457 8.43623 10.7519 8.83205L7.5547 10.9635C6.89015 11.4066 6 10.9302 6 10.1315Z"/></svg>
</template>
<script>

export default {
  name: 'IconPoint',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
